import '~/js/sections/weddings/includes/stickyNav';

// Display registry gift modal
const giftToggle = document.querySelectorAll('#js-registry__toggle');
const closeGiftToggle = document.querySelectorAll('#js-registry__close');
const giftModal = document.querySelectorAll('.registry__modal');

const getStartedBtn = document.querySelectorAll('.get-started');

//Gift Modal
getStartedBtn.forEach(item => {
  item.addEventListener('click', () => {
    document.getElementById('agree-popup').classList.remove('hide');
  });
});

function toggleGiftModal(index) {
  giftModal[index].classList.toggle('visible');
}

giftToggle.forEach((item, index) => {
  item.addEventListener('click', () => toggleGiftModal(index));
  closeGiftToggle[index].addEventListener('click', () =>
    toggleGiftModal(index)
  );
});